var React = require('react');

function IconArrowRoundBack (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Icon_ionic-ios-arrow-round-back","dataName":"Icon ionic-ios-arrow-round-back","d":"M13.678,11.456a.726.726,0,0,1,.006,1.023l-3.373,3.385H23.165a.722.722,0,0,1,0,1.445H10.311l3.379,3.385a.731.731,0,0,1-.006,1.023.72.72,0,0,1-1.017-.006L8.088,17.1h0a.811.811,0,0,1-.15-.228.69.69,0,0,1-.056-.278.724.724,0,0,1,.206-.506l4.579-4.613A.708.708,0,0,1,13.678,11.456Z","transform":"translate(-7.882 -11.252)","fill":"#686868"}));
}

IconArrowRoundBack.defaultProps = {"width":"16","height":"10.671","viewBox":"0 0 16 10.671"};

module.exports = IconArrowRoundBack;

IconArrowRoundBack.default = IconArrowRoundBack;
